module.exports = __webpack_public_path__ + "img/night.a90f4720.png";